/**
 *
 * Adicionado a remoção de caracteres especiais utilizando uma expressão regular.
 * Converter a string para maiúsculas ao invés de utilizar toLocaleUpperCase
 * Utilizar a spread operator (...) ao invés de split e join para converter uma string em um array e vice-versa.
 * Utilizar o Set para remover duplicatas da string ordenada e convertê-lo novamente em uma string com join.
 */

/**
 * Cria uma chave única a partir de uma string, removendo vogais, caracteres especiais e duplicatas e convertendo-a para maiúsculas.
 *
 * @param {string} str - A string de entrada.
 * @returns {string} - A chave única resultante.
 */
export function createUniqueKey(str: string): string {
  let unique = ''

  const specialCharsRemoved = str.replace(/[^\w\s]/gi, '')
  const vowelsRemoved = specialCharsRemoved.replace(/[aeiou]/gi, '')
  const uppercase = vowelsRemoved.toUpperCase()
  const sorted = [...uppercase].sort().join('')

  for (let i = 0; i < sorted.length; i++) {
    if (!unique.includes(sorted[i])) {
      unique += sorted[i]
    }
  }

  return unique
}
